import * as React from "react";
import type { SVGProps } from "react";
const SvgDigitalExpansion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={65}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M13.727 43.28v-8.831h8.83v8.83h-8.83Zm1.966-1.967h4.898v-4.898h-4.898v4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M13.727 36.415v-8.83h8.83v8.83h-8.83Zm1.966-1.966h4.898v-4.898h-4.898v4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M13.727 29.551v-8.83h8.83v8.83h-8.83Zm1.966-1.966h4.898v-4.898h-4.898v4.898ZM6.864 39.847v-8.83h8.83v8.83h-8.83Zm1.966-1.966h4.898v-4.898H8.83v4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M-.001 36.415v-8.83h8.83v8.83H0Zm1.966-1.966h4.898v-4.898H1.965v4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M6.864 32.983v-8.83h8.83v8.83h-8.83Zm1.966-1.966h4.898v-4.898H8.83v4.898ZM41.44 43.284v-8.83h8.831v8.83h-8.83Zm1.967-1.967h4.898V36.42h-4.898v4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M41.44 36.42v-8.83h8.831v8.83h-8.83Zm1.967-1.967h4.898v-4.898h-4.898v4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M41.44 29.555v-8.83h8.831v8.83h-8.83Zm1.967-1.966h4.898v-4.898h-4.898v4.898ZM48.306 39.852v-8.83h8.83v8.83h-8.83Zm1.966-1.967h4.898v-4.898h-4.898v4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M55.169 36.42v-8.83h8.83v8.83h-8.83Zm1.966-1.967h4.898v-4.898h-4.898v4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M48.306 32.987v-8.83h8.83v8.83h-8.83Zm1.966-1.966h4.898v-4.898h-4.898v4.898ZM43.278 50.276h-8.83v-8.83h8.83v8.83Zm-1.966-1.966v-4.898h-4.898v4.898h4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M36.415 50.276h-8.83v-8.83h8.83v8.83Zm-1.966-1.966v-4.898H29.55v4.898h4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.55 50.276h-8.83v-8.83h8.83v8.83Zm-1.966-1.966v-4.898h-4.898v4.898h4.898ZM39.847 57.14h-8.83v-8.83h8.83v8.83Zm-1.966-1.966v-4.898h-4.898v4.898h4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M36.415 64.005h-8.83v-8.83h8.83v8.83Zm-1.966-1.967v-4.897H29.55v4.897h4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.982 57.14h-8.83v-8.83h8.83v8.83Zm-1.966-1.966v-4.898h-4.898v4.898h4.898ZM43.278 22.558h-8.83v-8.83h8.83v8.83Zm-1.966-1.966v-4.898h-4.898v4.898h4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M36.415 22.558h-8.83v-8.83h8.83v8.83Zm-1.966-1.966v-4.898H29.55v4.898h4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.55 22.558h-8.83v-8.83h8.83v8.83Zm-1.966-1.966v-4.898h-4.898v4.898h4.898ZM39.847 15.694h-8.83v-8.83h8.83v8.83Zm-1.966-1.966V8.83h-4.898v4.898h4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M36.415 8.83h-8.83V0h8.83v8.83Zm-1.966-1.966V1.966H29.55v4.898h4.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.982 15.694h-8.83v-8.83h8.83v8.83Zm-1.966-1.966V8.83h-4.898v4.898h4.898Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M41.923 22.102H22.061v19.862h19.862V22.102Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M21.079 21.12h21.828v21.827H21.079V21.12Zm1.966 1.965v17.896H40.94V23.085H23.045Z"
      clipRule="evenodd"
    />
    <path fill="#26A3DD" d="M37.008 27.053h-9.965v9.964h9.965v-9.964Z" />
  </svg>
);
export default SvgDigitalExpansion;
